export default __webpack_public_path__ + "static/media/1777.7508d032.png";